/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Empty_Subtitle1Inputs */

const en_coinvestments_insights_empty_subtitle1 = /** @type {(inputs: Coinvestments_Insights_Empty_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insights will appear once there is co-investment activity`)
};

/**
* | output |
* | --- |
* | "Insights will appear once there is co-investment activity" |
*
* @param {Coinvestments_Insights_Empty_Subtitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_empty_subtitle1 = /** @type {((inputs?: Coinvestments_Insights_Empty_Subtitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Empty_Subtitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_empty_subtitle1(inputs)
});
export { coinvestments_insights_empty_subtitle1 as "coInvestments_insights_empty_subtitle" }